import { STATIC_URL, PROMO_REDIRECT_URL } from 'constants/data'
import { IObj } from 'constants/types/common.types'

type YoutubeStatus = 0 | 1 | undefined

const PlayerStatus: IObj<number> = {
  UNSTARTED: -1,
  END: 0,
  PLAYING: 1,
  PAUSE: 2,
  BUFFERING: 3,
  VIDEO_CUED: 5,
}

enum YandexPlayerStatuses {
  IDLE = 'idle',
  INIT = 'init',
  BUFFERING = 'buffering',
  PLAY = 'play',
  PAUSE = 'pause',
  END = 'end',
  FATAL = 'fatal',
  BROKEN = 'broken',
  DESTROYED = 'destroyed',
  CANCELLED = 'cancelled',
  PREPARING = 'preparing',
  FINISHED = 'finished',
}

const statisticPlayerEvents = [PlayerStatus.PLAYING, PlayerStatus.END]

const statisticEvent = {
  [PlayerStatus.PLAYING]: 'playVideo',
  [PlayerStatus.PAUSE]: 'pauseVideo',
  [PlayerStatus.END]: 'endVideo',
}

const translationOpts = {
  playerVars: {
    controls: 0 as YoutubeStatus,
    origin: PROMO_REDIRECT_URL,
    playsinline: 1 as YoutubeStatus,
    rel: 0 as YoutubeStatus,
    autoplay: 1 as YoutubeStatus,
    mute: 1 as YoutubeStatus,
  },
}

const videoOpts = {
  playerVars: {
    controls: 1 as YoutubeStatus,
    origin: PROMO_REDIRECT_URL,
    playsinline: 1 as YoutubeStatus,
    rel: 0 as YoutubeStatus,
    autoplay: 0 as YoutubeStatus,
  },
}

const vkIframeAllow = 'autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;'

const imgPath = {
  fullscreen: `${STATIC_URL}/youtube/fullscreen_on.svg`,
  exitfullscreen: `${STATIC_URL}/youtube/fullscreen_off.svg`,
  volume: `${STATIC_URL}/youtube/sound_on.svg`,
  volume_white: `${STATIC_URL}/youtube/sound_on_white.svg`,
  mute: `${STATIC_URL}/youtube/sound_off.svg`,
}

const MIN_CHAT_HEIGHT = 226
const INPUT_HEIGHT = 130
const BUTTON_FAQ_HEIGHT = 75
const MIN_HEIGHT = 214
const CHAT_HEADER = 50
const ScrollConfig = { inaccuracy: 10 }

const GapMessage = {
  ENDED: 'Вебинар окончен',
  BLOCKED: 'Отправка сообщений ограничена',
  HOUR_BEFORE: 'Чат станет доступен после начала трансляции',
  NOT_AUTHORIZED: 'Чат доступен только зарегистрированным пользователям',
  NOT_FILLED: 'Для доступа к чату необходимо дополнить информацию о себе',
}

enum Action {
  SET_PARAMETERS = 'SET_PARAMETERS',
  SET_MUTE = 'SET_MUTE',
  SET_PAUSE = 'SET_PAUSE',
  SET_INIT_DATA = 'SET_INIT_DATA',
}

type UserAction =
  | { type: Action.SET_PARAMETERS; payload: any }
  | { type: Action.SET_INIT_DATA }
  | { type: Action.SET_MUTE; payload: any }
  | { type: Action.SET_PAUSE; payload: any }

const initData = {
  isFirstLoaded: false,
  isPaused: true,
  isVideoBug: false,
  isVideoBugScreen: false,
  isMuted: true,
  isClicked: false,
  canPlay: false,
}

const reducer = (state: any, action: UserAction) => {
  switch (action.type) {
    case Action.SET_PARAMETERS: {
      return { ...state, ...action.payload }
    }
    case Action.SET_MUTE: {
      if (state.isMuted === action.payload) return state
      return { ...state, isMuted: action.payload }
    }
    case Action.SET_PAUSE: {
      if (state.isPaused === action.payload) return state
      return { ...state, isPaused: action.payload }
    }
    case Action.SET_INIT_DATA: {
      return {
        ...state,
        ...initData,
      }
    }
  }
}

const TICK = 10000

const VK_CONTROLS_SHOW_TIME = 0
const DEFAULT_CONTROLS_SHOW_TIME = 5000

export {
  PlayerStatus,
  imgPath,
  statisticEvent,
  translationOpts,
  videoOpts,
  MIN_CHAT_HEIGHT,
  INPUT_HEIGHT,
  BUTTON_FAQ_HEIGHT,
  MIN_HEIGHT,
  CHAT_HEADER,
  ScrollConfig,
  GapMessage,
  statisticPlayerEvents,
  reducer,
  initData,
  Action,
  vkIframeAllow,
  TICK,
  VK_CONTROLS_SHOW_TIME,
  DEFAULT_CONTROLS_SHOW_TIME,
  YandexPlayerStatuses,
}
